module.exports = __webpack_public_path__ + "task.9ba4b7c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/xmas/task.png
// module id = 916
// module chunks = 0